export { render } from './render';

export const nodeConfig = {
  nodes: {
    paragraph: {
      render: 'Paragraph',
    },
    heading: {
      render: 'Heading',
    },
    fence: {
      render: 'Code',
    },
    list: {
      render: 'List',
    },
  },
};
